(function() {
    'use strict';

    angular
        .module('exhibitorRegistrationApp')
        .controller('RegisterController', RegisterController);


    RegisterController.$inject = ['$translate', '$timeout', 'Auth', 'LoginService', '$localStorage', 'AccountService', '$log', '$rootScope'];

    function RegisterController ($translate, $timeout, Auth, LoginService, $localStorage, AccountService, $log, $rootScope) {
        var vm = this;
        vm.showPassword = false;
        vm.doNotMatch = null;
        vm.error = null;
        vm.errorUserExists = null;
        vm.login = LoginService.open;
        vm.register = register;
        vm.togglePasswordVisibility = togglePasswordVisibility;
        vm.registerAccount = {};
        vm.success = null;
        vm.registerAccount.projectID = $localStorage.project;
        vm.lang = $translate.use();


        $rootScope.$on('$translateChangeSuccess', function () {
            vm.lang = $translate.use();
            translateComboBoxValues(vm.salutations);
        });

        loadValues();

        function loadValues() {
            AccountService.loadSalutations().then(successSalutations, error);
            AccountService.loadTitles().then(successTitles, error);
        }

        function togglePasswordVisibility(){
            vm.showPassword = !vm.showPassword;
        }

        function successSalutations(response) {
            $log.debug('RegisterController | fetching salutations:', response);
            vm.salutations = response.data;
            translateComboBoxValues(vm.salutations);
        }
        function successTitles(response) {
            $log.debug('RegisterController | fetching titles:', response);
            vm.academictitles = response.data;
            translateComboBoxValues(vm.academictitles);
        }

        function translateComboBoxValues(array) {
            var values = [];
            angular.forEach(array, function (value) {
                value.name = value.translations[vm.lang];
                values.push(value);
            });
            array = values;
        }

        function error(response) {
            $log.debug('RegisterController | ERROR:', response);
        }

        $timeout(function (){angular.element('#login').focus();});

        function register () {
            if (vm.registerAccount.password !== vm.confirmPassword) {
                vm.doNotMatch = 'ERROR';
            } else {
                vm.registerAccount.langKey = $translate.use();
                vm.doNotMatch = null;
                vm.error = null;
                vm.errorUserExists = null;
                vm.errorEmailExists = null;

                Auth.createAccount(vm.registerAccount).then(function () {
                    vm.success = 'OK';
                }).catch(function (response) {
                    vm.success = null;
                    if (response.status === 400 && response.data === 'login already in use') {
                        vm.errorUserExists = 'ERROR';
                    } else if (response.status === 400 && response.data === 'e-mail address already in use') {
                        vm.errorEmailExists = 'ERROR';
                    } else {
                        vm.error = 'ERROR';
                    }
                });
            }
        }
    }
})();
